import type { ResponsiveStyleValue } from '@mui/system';

// Returns a percentage css string value from a fraction
// Top refers to dividend and bottom refers to divisor
export function fractionToPercent(top: number, bottom: number): string {
  return `calc(100% * (${top} / ${bottom}))`;
}

export const darkOrLightStyle =
  ({ isOnDark }: { isOnDark?: boolean } = { isOnDark: false }) =>
  (darkStyle: string, lightStyle: string, isImportant?: boolean): string => {
    return `${isOnDark ? darkStyle : lightStyle}${
      isImportant ? '!important' : ''
    }`;
  };

// Takes a @mui/system ResponsiveStyleValue and normalizes it to a map
// from breakpoints to values
export const normalizeBreakpointValues = <T>(
  responsiveStyleValue: ResponsiveStyleValue<T>
): Record<string, T> => {
  let result: Record<string, T | null | undefined>;

  if (Array.isArray(responsiveStyleValue)) {
    const [xs, sm, md, lg, xl] = responsiveStyleValue;
    result = { xs, sm, md, lg, xl };
  } else if (
    typeof responsiveStyleValue === 'object' &&
    responsiveStyleValue !== null
  ) {
    result = responsiveStyleValue as Record<string, T | null | undefined>;
  } else {
    result = { xs: responsiveStyleValue as T };
  }

  return Object.fromEntries(
    Object.entries(result).filter(
      ([, value]) => value !== undefined && value !== null
    )
  ) as Record<string, T>;
};
